<style>
@import '../custom/css/fazer-cotacao.css';
.rem-cidade {
  right: 3px;
  top: -5px;
}

.icon-align {
  position: absolute;
  right: 20px;
}

.btnSearchUser {
  background: #ff6100;
  color: #FFF;
  padding: 5px 10px;
  border-radius: 4px;
  margin-left: -5px;
  padding-top: 10px;
  cursor: pointer;
}
.btnSearchUserEmailInValid { 
  background: #FFF;
  color: red;
  padding: 5px 10px;
  border-radius: 4px;
  padding-top: 10px;
}
.btnSearchUserEmail {
  background: #FFF;
  color: green;
  padding: 5px 10px;
  border-radius: 4px;
  padding-top: 10px;
}
.searchUser {
  margin: 25px 0;
  display: flex;
}
.sendQuoteWhatsapp {
  background: #28a745;
  color: #FFF;
  border-radius: 4px;
  padding: 5px 20px;
  cursor: pointer;
}
.sendQuoteWhatsapp i{
  font-size: 30px;
  margin-left: 2%;
  margin-right: 10%;
}
.sendQuoteWhatsapp span{
  font-size: 20px;
  font-weight: 600;
}
.especialistaWhstasapp a:hover { 
  text-decoration: none;
}
.especialistaWhstasapp {
  width: 35%;
  margin: 30px auto;
}
</style>

<template>
  <div class="fazer-cotacao" v-if="this.dadosUsuario !== null">
    <div
      v-if="
        this.dadosUsuario.tipo_usuario !== 'Representante' &&
        this.dadosUsuario.tipo_usuario !== 'Editor' &&
        this.dadosUsuario.tipo_usuario !== 'Lojista' &&
        this.dadosUsuario.tipo_usuario !== 'Afiliado'
      "
    >
      <div class="row m-0">
        <div class="col-12 p-0">
          <img
            class="banner-fazer-cotacao"
            src="@/assets/img/banner-fazer-cotacao.jpg"
            alt="Imagem do banner"
          />
        </div>
      </div>
      <div class="container">
        <div class="row m-0">
          <div class="col-12 p-0">
            <nav aria-label="breadcrumb">
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link class-active="active" :to="{ name: 'home' }">
                    Ínicio
                  </router-link>
                </li>
                <li
                  class="breadcrumb-item active text-uppercase"
                  aria-current="page"
                >
                  Fazer Orçamento
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-12 text-center m-b-10">
            <h1 class="h1-after-center text-uppercase fwb">Fazer Orçamento</h1>
            <h4 class="mt-3 text-center">Grátis e sem compromisso</h4>
          </div>
          <div v-if="isMobile()" class="col-12 text-center mx-auto">
            <h4 class="fs-18 mt-4">Orce e economize até 50% na sua obra</h4>
            <b-embed
              type="iframe"
              aspect="16by9"
              src="https://www.youtube.com/embed/GAYHErGesZU"
              allowfullscreen
            ></b-embed>
          </div>
          <div v-else class="col-6 text-center mx-auto">
            <b-embed
              type="iframe"
              aspect="16by9"
              src="https://www.youtube.com/embed/GAYHErGesZU"
              allowfullscreen
            ></b-embed>
          </div>
          <div class="col-12">
            <div class="especialistaWhstasapp">
              <a href="https://bit.ly/Cotar-com-especialista-site"  target="_blank">
                <div class="sendQuoteWhatsapp">
                  <i class="fab fa-whatsapp"></i>
                  <span>COTAR COM ESPECIALISTA</span>
                </div>
              </a>
            </div>
          </div>
          <!--********************* BOX 1 *******************-->
          <div class="col-12 m-b-30" id="cidadeCotacao">
            <b-card-group deck>
              <b-card header-tag="header">
                <h6 slot="header" class="m-0">
                  <div class="row m-0">
                    <div
                      style="width: 10%; font-size: 3rem; white-space: nowrap"
                      class="letter-orange"
                    >
                      1.
                    </div>
                    <div style="width: 80%" class="text- my-auto p-2">
                      Selecione a distância que você deseja receber os
                      orçamentos:
                    </div>
                    <div
                      style="width: 10%"
                      class="text-center my-auto c-gray-2"
                    >
                      <i class="fas fa-map-marked-alt fa-2x"></i>
                    </div>
                    <div class="searchUser" v-if="this.dadosUsuario.tipo_usuario == 'Administrador'">
                      <input type="text" class="mailClient form-control" v-model="validEmailUser" placeholder="E-Mail do cliente">
                      <span class="btnSearchUser" @click="showUserValid()">Buscar</span>
                      <span class="btnSearchUserEmail" v-if="showEmailUser.id != null">Valido</span>
                      <span class="btnSearchUserEmailInValid" v-if="showEmailUser.id == null">Invalido</span>
                    </div>
                  </div>
                </h6>
                <b-card-text>
                  <div class="row m-0">
                    <div class="col-sm p-0 m-b-15">
                      <div>
                        <div autocomplete="off">
                          <input
                            class="search"
                            type="text"
                            placeholder="Pesquisar endereço"
                            ref="origin_search"
                            @input="errorMessagesQuote.city = null"
                            autocomplete="new-password"
                          />
                        </div>
                        <div id="map"></div>
                        <button @click="getLocationBtn()" id="my-location">
                          <i class="fas fa-location-arrow"></i>Usar minha
                          localização
                        </button>
                        <h4>Escolha a distância que deseja cotar</h4>
                        <div class="flex">
                          <input
                            id="rangeinput"
                            class="range"
                            v-model="radius"
                            min="1"
                            max="100"
                            type="range"
                          />
                          <input class="selector" v-model="radius" />
                          <span class="selector-h1">KM</span>
                        </div>
                        <div class="estimativa" v-if="lojistas >= 0">
                          <p>Cerca de <strong> {{ lojistas }} </strong> Lojistas foram localizados</p>
                        </div>
                      </div>
                      <!--                      <v-select-->
                      <!--                        style="white-space: normal"-->
                      <!--                        class="p-right-10px"-->
                      <!--                        v-model="cidadesDePedido[index]"-->
                      <!--                        label="nome"-->
                      <!--                        :options="getCidadeItem(cidadesDePedido[index])"-->
                      <!--                        placeholder="Escolha uma cidade"-->
                      <!--                        @input="errorMessagesQuote.city = null"-->
                      <!--                      >-->
                      <!--                        <div slot="no-options">-->
                      <!--                          Desculpe, ainda não estamos nessa cidade!-->
                      <!--                        </div>-->
                      <!--                      </v-select>-->
                      <p
                        style="width: 274px"
                        class="error-message text-danger"
                        v-if="errorMessagesQuote.city !== null"
                      >
                        {{ errorMessagesQuote.city }}
                      </p>
                    </div>
                  </div>
                </b-card-text>
                <div slot="footer" v-if="cidadesDePedido">
                  <!--                  <button-->
                  <!--                    type="button"-->
                  <!--                    class="btn bg-orange text-white"-->
                  <!--                    @click="addRowCity()"-->
                  <!--                  >-->
                  <!--                    <i class="fas fa-plus mr-2"></i>-->
                  <!--                    <span>Adicione mais uma cidade</span>-->
                  <!--                  </button>-->
                </div>
              </b-card>
            </b-card-group>
          </div>
          <!--********************* BOX 3 *******************-->
          <div class="col-12 m-b-30">
            <b-card-group deck>
              <b-card header-tag="header">
                <h6 slot="header" class="m-0 d-flex align-items-center">
                  <div class="number letter-orange">2.</div>
                  <div class="text-header" style="max-width: 75%">
                    Decida de acordo com a sua preferência o que o lojista
                    deverá priorizar
                    <!-- <span
                      v-if="
                        dadosUsuario.tipo_usuario_id === userTypes.CLIENT ||
                        dadosUsuario.tipo_usuario_id === userTypes.PROFESSIONAL
                      "
                    >
                    </span>
                    <span
                      v-else-if="
                        dadosUsuario.tipo_usuario_id === userTypes.SHOPKEEPER
                      "
                    >representante</span> -->
                  </div>
                  <div
                    style="width: 10%"
                    class="number c-gray-2 my-auto icon-align mb-2"
                  >
                    <i class="fab fa-wpforms fs-12 mb-3 fa-xs"></i>
                  </div>
                </h6>
                <b-card-text>
                  <div class="form-group m-0">
                    <div
                      class="
                        custom-control custom-radio
                        d-flex
                        justify-content-around
                        mt-3
                      "
                    >
                      <div class="p-right-10px">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="prioridade"
                          id="menor-preco"
                          value="1"
                          @input="errorMessagesQuote.preference = null"
                        />
                        <label
                          class="custom-control-label p-1"
                          for="menor-preco"
                          >Menor Preço
                        </label>
                      </div>
                      <div class="p-left-10px">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="prioridade"
                          id="custo-beneficio"
                          value="2"
                          @input="errorMessagesQuote.preference = null"
                        />
                        <label
                          class="custom-control-label"
                          for="custo-beneficio"
                        >
                          Custo-Benefício
                        </label>
                      </div>
                      <div class="p-left-10px">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="prioridade"
                          id="melhor-marca"
                          value="3"
                          @input="errorMessagesQuote.preference = null"
                        />
                        <label class="custom-control-label" for="melhor-marca"
                          >Melhor Marca</label
                        >
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card>
            </b-card-group>
          </div>
          <!--********************* BOX 4 *******************-->
          <div class="col-12 m-b-30">
            <b-card-group deck>
              <b-card header-tag="header">
                <h6
                  slot="header"
                  class="m-0 d-flex align-items-center"
                  style="max-width: 90%"
                >
                  <div class="number letter-orange">3.</div>
                  <div class="text-header mt-2" style="max-width: 80%">
                    Digite os materiais, quantidade e marca de sua preferência.
                    <br />
                    <span class="c-gray-3 fa-sm" style="max-width: 70%">
                      Caso você não defina uma marca ou o lojista não disponha da marca escolhida,
                      ele poderá sugerir outra opção baseada na prioridade definida no passo anterior
                    </span>
                  </div>
                  <div
                    style="width: 10%"
                    class="number c-gray-2 ml-1 icon-align mb-4"
                  >
                    <i class="fas fa-pencil-ruler fa-xs"></i>
                  </div>
                </h6>
                <div class="container">
                  <div class="row">
                    <div
                      class="col-4 cotacao-div bd-right"
                      style="padding: 0px"
                    >
                      <div
                        :class="isClicked ? 'c-click' : ''"
                        @click="
                          () => {
                            toggleButton();
                            if (this.initialProduct === false) {
                              this.addRowProduct();
                              this.initialProduct = true;
                            }
                            productSelect = !productSelect;
                          }
                        "
                      >
                        <div>
                          <i class="fas fa-list-ul fs-24 mr-2"></i>
                        </div>
                        <div>
                          <span> Produtos </span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-4 cotacao-div bd-right"
                      style="padding: 0px"
                    >
                      <div
                        v-bind:class="isClicked1 ? 'c-click' : ''"
                        v-on:click="toggleButton1()"
                        @click="Archive = !Archive"
                      >
                        <div>
                          <i class="fas fa-file fs-24 mr-2"></i>
                        </div>
                        <div>
                          <span>Arquivo</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 cotacao-div" style="padding: 0px">
                      <div
                        :class="isClicked2 ? 'c-click' : ''"
                        @click="toggleButton2()"
                      >
                        <div>
                          <i class="fas fa-images fs-24"></i>
                        </div>
                        <div>
                          <span>Fotos</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <ul class="slide-nav mb-5 mt-3">
                      <li class="nav-item">
                        <transition name="fade">
                          <div class="sub-text" v-show="productSelect">
                            <div
                              class="container my-5"
                              v-for="(item, index) in listaDeProdutos"
                              @click="getTheIdLista(item.id)"
                              :key="index"
                            >
                              <div class="row col">
                                <div class="d-inline">
                                  <span
                                    class="fonte-numero"
                                    >{{ index + 1 }}º item  
                                  </span>
                                </div>

                                <div class="d-inline ml-3">
                                  <VoiceText @textvoice="setProductVoice($event)"/>
                                </div>

                                <div class="d-inline ml-3">
                                  <button class="btn-icon" @click="$bvModal.show('leitor')">
                                     <img class="sizeIcon" src="../../public/img/icons/barcode.png" alt="codigo de barras em png" />
                                  </button>
                                </div>
                              </div>
                             
                               <!-- MODAL CODIGO DE BARRA -->
                               <b-modal
                                  title="Ler codigo de barras"
                                  size="lg"
                                  id="leitor"
                                  header-bg-variant="orange"
                                  header-text-variant="light"
                                  centered
                                  hide-footer
                                >
                                  <StreamBarcodeReader @decode="onDecode"> </StreamBarcodeReader>
                                </b-modal>
                                <!-- FIM MODAL LEITOR DE CODIGO DE BARRAS -->

                              <div class="row">
                               
                                <!--  COLUNA DIGITE UM PRODUTO LEITOR DE CODIGO DE BARRAS -->
                                  <div class="col-xl-3" v-if="barcode[index]">
                                   <label for="selectProduct" class="fonte-laranja my-2">Nome *</label>
                                    <input 
                                      v-model="productBarcode" 
                                      type="text" 
                                      class="form-control" 
                                      placeholder="leia o produto com o codigo de barras"
                                    >
                                  </div>

                                <!--  COLUNA DIGITE UM PRODUTO -->
                                <div class="col-xl-4"  v-else>
                                  <label
                                    for="selectProduct"
                                    class="fonte-laranja my-2"
                                    >Nome *</label
                                  >
                                  <v-select
                                    style="max-width: 100%"
                                    label="nome"
                                    id="nomeProduto"
                                    ref="selectProduct"
                                    class="m-0-auto-right custom_product placeholder_custom"
                                    placeholder="Digite um produto"
                                    v-model="item.produto"
                                    :options="searchProductsResult"
                                    @search="searchProducts"
                                    @search:focus="searchProductsResult = []"
                                    :clearSearchOnBlur="
                                      () => {
                                        pushTagOnBlur(
                                          'listaDeProdutos',
                                          index,
                                          'produto',
                                          'Product'
                                        );
                                      }
                                    "
                                    @input="
                                      errorMessagesQuote.product[index] = null
                                    "
                                  >
                                    <template #no-options>
                                      Digite o nome do produto
                                    </template>
                                  </v-select>

                                  <span class="d-lg-none d-xl-block">
                                    <p
                                      style="position: absolute"
                                      class="error-message text-danger"
                                      v-if="
                                        errorMessagesQuote.product[index] !==
                                        null
                                      "
                                    >
                                      {{ errorMessagesQuote.product[index] }}
                                    </p>
                                  </span>

                                  <span
                                    class="
                                      d-none
                                      d-lg-block
                                      d-xl-none
                                      d-none
                                      d-md-block
                                      d-lg-none
                                      d-none
                                      d-sm-block
                                      d-md-none
                                      d-block
                                      d-sm-none
                                    "
                                  >
                                    <p
                                      class="error-message text-danger"
                                      v-if="
                                        errorMessagesQuote.product[index] !==
                                        null
                                      "
                                    >
                                      {{ errorMessagesQuote.product[index] }}
                                    </p>
                                  </span>
                                </div>
                                <!--  COLUNA QUANTIDADE -->
                                <div class="col-xl-2">
                                  <label
                                    for="quantidade"
                                    class="fonte-laranja my-2"
                                    >Quantidade*</label
                                  >
                                  <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                      <button id="btn-sub" v-if="mostInput(index)" v-show="mostButton" :class="[item.qtd == 1 ? 'none-btn' : null]" class="input-group-text bg-orange c-white sub-btn" @click="subNumber(index)"><i class="fas fa-minus"></i></button>
                                      <button id="btn-sub" v-else v-show="activeInput(index)" :class="[item.qtd == null ? 'none-btn' : null]" class="input-group-text bg-orange c-white sub-btn" @click="subNumber(index)"><i class="fas fa-minus"></i></button>
                                    </div>
                                    <input
                                      id="qnt"
                                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                      type="number"
                                      class="text-center form-control input-form qtd-number"
                                      v-model="item.qtd"
                                      maxlength="6"
                                      min="0"
                                      max="999999"
                                      @input="
                                        errorMessagesQuote.amount[index] = null
                                      "
                                    />
                                    <div class="input-group-append">
                                      <button class="input-group-text bg-orange c-white" @click="addNumber(index)"><i class="fas fa-plus"></i></button>
                                    </div>
                                    <div v-if="teste" :class="[item.qtd == null ? 'font-most' : null]" class="text-danger">{{ warningMessage }}</div>
                                    <div v-else v-show="messageInput" :class="[item.qtd == 0 ? 'font-most' : null]" class="text-danger">{{ warningMessage }}</div>
                                  </div>

                                  
                                  <p
                                    style="width: 100px"
                                    class="error-message text-danger"
                                    v-if="
                                      errorMessagesQuote.amount[index] !== null
                                    "
                                  >
                                    {{ errorMessagesQuote.amount[index] }}
                                  </p>
                                </div>
                                <!--  COLUNA UNIDADE DE MEDIDA -->
                                <div class="col-xl-2">
                                  <label for="medida" class="fonte-laranja my-2"
                                    >Medida</label
                                  >
                                  <span
                                    class="opcional"
                                    style="text-align: end"
                                  >
                                    (Opcional)</span
                                  >
                                  <v-select
                                    v-if="
                                      item &&
                                      item.produto &&
                                      item.produto.medidas
                                    "
                                    id="mdd"
                                    class="d-inline-block"
                                    v-model="item.medida"
                                    ref="selectMdd"
                                    label="nome"
                                    :options="item.produto.medidas"
                                    :clearSearchOnBlur="
                                      () => {
                                        pushTagOnBlur(
                                          'listaDeProdutos',
                                          index,
                                          'medida_nome',
                                          'Mdd'
                                        );
                                      }
                                    "
                                  >
                                    <template #no-options>
                                      Digite a medida
                                    </template>
                                  </v-select>

                                  <v-select
                                    v-else
                                    id="mdd"
                                    class="d-inline-block"
                                    ref="selectMdd"
                                    v-model="item.medida"
                                    label="nome"
                                    :options="tipoMedidas"
                                    :clearSearchOnBlur="
                                      () => {
                                        pushTagOnBlur(
                                          'listaDeProdutos',
                                          index,
                                          'medida_nome',
                                          'Mdd'
                                        );
                                      }
                                    "
                                  >
                                    <template #no-options>
                                      Digite a medida
                                    </template>
                                  </v-select>
                                </div>
                                <!--  COLUNA MARCA -->
                                <div class="col-xl-2">
                                  <label for="marca" class="fonte-laranja my-2"
                                    >Marca</label
                                  >
                                  <span
                                    class="opcional"
                                    style="text-align: end"
                                  >
                                    (Opcional)</span
                                  >
                                  <v-select
                                    id="mrc"
                                    taggable
                                    class="m-0-auto-right custom_product"
                                    ref="selectBrand"
                                    placeholder="Escolha ou digite"
                                    label="nome"
                                    v-model="item.marca"
                                    :options="produtoMarcas"
                                    :clearSearchOnBlur="
                                      () => {
                                        pushTagOnBlur(
                                          'listaDeProdutos',
                                          index,
                                          'marca',
                                          'Brand'
                                        );
                                      }
                                    "
                                  ></v-select>
                                </div>
                                <!--  COLUNA FOTO -->
                                <div class="col my-2 p-0 text-center">
                                  <span class="fonte-laranja">Imagem</span>
                                  <div
                                    class="subImage"
                                    v-if="item.adicionarFoto === null"
                                  >
                                    <label :for="'file' + item.id">
                                      <a class="pointer">
                                        <i class="fas fa-camera fs-24 my-3">
                                        </i>
                                      </a>
                                    </label>
                                    <input
                                      :id="'file' + item.id"
                                      ref="file"
                                      @change="addProductPhoto(index)"
                                      accept=".jpg, .jpeg, .png"
                                      class="d-none"
                                      type="file"
                                    />
                                  </div>
                                  <div
                                    v-if="item.adicionarFoto !== null"
                                    class="subImage text-center"
                                  >
                                    <a class="pointer">
                                      <img
                                        class="img-small"
                                        :src="
                                          `${getImagesAddress}` +
                                          item.adicionarFoto
                                        "
                                      />
                                    </a>
                                    <div class="position-relative">
                                      <div
                                        class="btn-remove"
                                        @click="
                                          deleteProductPhoto(
                                            item.adicionarFoto,
                                            index
                                          )
                                        "
                                      >
                                        <i class="fas fa-times"></i>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col my-2 p-0 text-center">
                                  <label class="fonte-laranja">Remover</label>
                                  <div
                                    class="btn-remove-item c-red c-pointer"
                                    @click="removeProduct(index)"
                                    v-if="index !== 0 || file || imagem"
                                  >
                                    <i class="fas fa-trash-alt fs-22 mt-2"></i>
                                  </div>
                                </div>
                              </div>

                              <div>
                                <hr class="mt-4" />
                              </div>
                            </div>
                            <!-- FIM ROW -->

                            <!-- FIM CONTAINER-->
                            <div>
                              <button
                                type="button"
                                class="
                                  btn
                                  bg-orange
                                  text-white
                                  btn-adicionar
                                  ml-4
                                  my-1
                                "
                                @click="addRowProduct()"
                              >
                                <i class="fas fa-plus"></i>
                                Adicionar mais um item
                              </button>
                              <hr />
                            </div>
                          </div>
                        </transition>
                      </li>
                    </ul>
                  </div>
                </div>

                <ul class="slide-nav mb-5" style="z-index: 100">
                  <li class="nav-item">
                    <transition name="fade">
                      <div class="sub-text" v-show="Archive">
                        <li class="sub-item">
                          <div class="upload-pedido">
                            <h6 class="d-title">
                              Você pode enviar até <b> 1 arquivo</b> PDF ou XLS
                              (Excel) de até 5MB da sua lista de materiais
                              pronta.
                            </h6>
                            <div
                              class="qtd-itens d-flex flex-row align-items-end"
                            >
                              <!-- <div class="form-group d-inline-block">
                          <label
                            for="QuantidadeItensArquivo"
                            class="titulo"
                          >
                            Quantos itens na lista?
                          </label>
                          <input
                            type="number"
                            class="form-control input-form"
                            v-model="quantidade_arquivo"
                            id="QuantidadeItensArquivo"
                            min="0"
                            placeholder="0"
                          />
                        </div> -->
                              <div class="form-group d-inline-block">
                                <label
                                  for="file"
                                  class="
                                    btn btn-primary
                                    c-pointer
                                    fs-14
                                    text-uppercase
                                    bg-dark-blue
                                  "
                                >
                                  Enviar Arquivo
                                  <i class="fas fa-file-upload m-l-7px"></i>
                                </label>
                                <input
                                  type="file"
                                  id="file"
                                  class="d-none"
                                  accept=".pdf, .xlsx, .xls"
                                  @change="addFile()"
                                />
                              </div>
                            </div>
                          </div>

                          <hr />
                          <div
                            v-if="file !== null && originalFileName !== null"
                            class="mb-2 ml-2"
                          >
                            <td class="d-flex flex-row align-items-center">
                              <span
                                class="
                                  badge badge-light
                                  fs-14
                                  font-weight-normal
                                "
                              >
                                Arquivo
                                <span class="c-orange font-weight-bold">
                                  {{ originalFileName }}
                                </span>
                                adicionado!
                              </span>
                              <span
                                class="badge badge-danger pointer"
                                @click="deleteFile(file)"
                              >
                                <i
                                  title="Remover o arquivo"
                                  class="fas fa-times c-white"
                                >
                                </i>
                              </span>
                            </td>
                          </div>
                        </li>
                      </div>
                    </transition>
                  </li>
                </ul>

                <ul class="slide-nav">
                  <li class="nav-item">
                    <transition>
                      <div class="sub-text" v-show="ProductPhoto">
                        <li class="sub-item">
                          <div class="upload-pedido mb-negative-1v25em">
                            <h6 class="d-title fs-14">
                              Você pode enviar ou tirar até <b>5 fotos</b> da
                              lista de materiais com boa qualidade e
                              legibilidade. (Para adicionar mais uma foto é só
                              clicar no botão novamente 😄)
                            </h6>
                            <div class="qtd-itens">
                              <!-- <div class="form-group d-inline-block">
                    <label for="QuantidadeItensFoto" class="titulo">
                      Quantos itens na lista?
                    </label>
                    <input
                      type="number"
                      class="form-control input-form"
                      v-model="quantidade_foto"
                      id="QuantidadeItensFoto"
                      min="0"
                      placeholder="0"
                    />
                  </div> -->
                              <div class="form-group d-inline-block">
                                <label
                                  for="photo"
                                  class="
                                    btn btn-primary
                                    c-pointer
                                    fs-14
                                    text-uppercase
                                    bg-dark-blue
                                  "
                                >
                                  Enviar Foto
                                  <i class="fas fa-file-upload m-l-7px"></i>
                                </label>
                                <input
                                  type="file"
                                  id="photo"
                                  class="d-none"
                                  accept=".jpg, .jpeg, .png"
                                  @change="addFiles()"
                                  multiple
                                />
                              </div>
                              <div
                                class="form-group d-inline-block"
                                v-if="false"
                              >
                                <div
                                  class="
                                    btn btn-primary
                                    c-pointer
                                    fs-14
                                    text-uppercase
                                    bg-dark-blue
                                  "
                                >
                                  Tirar Foto
                                  <i class="fas fa-camera m-l-7px"></i>
                                </div>
                              </div>
                              <div
                                v-if="imagem !== null && imagem !== []"
                                class="mb-2 ml-2"
                              >
                                <td class="subImage text-center">
                                  <a
                                    v-for="(image, index) in imagem"
                                    class="pointer"
                                    :key="index"
                                  >
                                    <img
                                      class="
                                        img-small img-preview
                                        mt-2
                                        mb-2
                                        mr-2
                                      "
                                      :src="`${getImagesAddress}` + image"
                                    />

                                    <i
                                      class="fas fa-times btn-remove-image"
                                      @click="deleteImage(image, index)"
                                    >
                                    </i>
                                  </a>
                                </td>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </transition>
                  </li>
                </ul>
              </b-card>
            </b-card-group>
          </div>
          <!-- ********************* BOX 2 ******************* -->
          <div
            v-if="ativaSeguimentos || validFiles === true"
            class="col-12 m-b-30"
            id="segmentoCotacao"
          >
            <b-card-group deck>
              <b-card header-tag="header" footer-tag="footer">
                <h6 slot="header" class="m-0 d-flex align-items-center">
                  <div class="number letter-orange">4.</div>
                  <div class="text-header" style="max-width: 60%">
                    Escolha os segmentos do orçamento:
                  </div>
                  <div style="width: 10%" class="number c-gray-2 iconAlign">
                    <i class="fas fa-edit fs-12 mb-4 fa-1x"></i>
                  </div>
                </h6>
                <b-card-text>
                  <div class="col-12 row m-0">
                    <div
                      class="col-12 p-0 m-b-15"
                      v-for="(grupo, index) in segmentosDaCotacao"
                      :key="index"
                    >
                      <v-select
                        class="p-right-5px m-0-auto-right"
                        v-model="segmentosDaCotacao[index]"
                        label="nome"
                        :options="getSegmentoItem(segmentosDaCotacao[index])"
                        placeholder="Escolha um segmento"
                        @input="errorMessagesQuote.segment = null"
                      >
                        <div slot="no-options">
                          Desculpe, ainda não operamos com esse segmento!
                        </div>
                      </v-select>
                      <p
                        style="width: 274px"
                        class="error-message text-danger"
                        v-if="errorMessagesQuote.segment !== null"
                      >
                        {{ errorMessagesQuote.segment }}
                      </p>
                      <div
                        class="btn-remove rem-cidade"
                        @click="removeSegment(index)"
                        v-if="index !== 0"
                      >
                        <i class="fas fa-times"></i>
                      </div>
                    </div>
                  </div>
                </b-card-text>
                <div slot="footer" v-if="segmentosDaCotacao">
                  <button
                    type="button"
                    class="btn bg-orange text-white"
                    @click="addRowSegment()"
                  >
                    <i class="fas fa-plus mr-2"></i>
                    <span>Adicione mais um segmento</span>
                  </button>
                </div>
              </b-card>
            </b-card-group>
          </div>
          <!--********************* BOX  *******************-->
          <div class="col-12 m-b-30" v-if="!checkIsEmpty(listaDeProdutos)">
            <b-card-group deck>
              <b-card header-tag="header">
                <h6
                  slot="header"
                  class="m-0 d-flex align-items-center"
                  style="max-width: 95%"
                >
                  <div class="number letter-orange">
                    {{ ativaSeguimentos === true ? '5' : '4' }}.
                  </div>
                  <div class="text-header mt-3">
                    Verifique os itens e envie seu orçamento
                  </div>
                  <div style="width: 100%" class="number c-gray-2 ml-0 iconAlign d-flex justify-content-end">
                    <i class="fas fa-paper-plane fa-xs"></i>
                  </div>
                </h6>
                <div class="mb-5">
                  <label for="nome_cotacao" class="font-weight-bold">
                    Dê um nome para seu orçamento (opcional)
                  </label>
                  <input
                    name="nome_cotacao"
                    type="text"
                    class="form-control"
                    v-model="nome_cotacao"
                    placeholder="Digite o nome do seu orçamento"
                  />
                </div>
                <div class="sub-text mt-negative-1v25em">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class="fonte-laranja">
                        <tr>
                          <th>Item</th>
                          <th>Nome</th>
                          <th>Qtd</th>
                          <th>Medida</th>
                          <th>Marca</th>
                          <th>Foto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in listaDeProdutos"
                          @click="getTheIdLista(item.id)"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>
                            
                            <div v-if="!checkIsEmpty(item.produto)">
                              {{
                                typeof item.produto === 'object'
                                  ? item.produto.nome
                                  : item.produto
                              }}
                            </div>
                            
                            <div v-else>Sem Produto</div>
                          </td>
                          <td>{{ item.qtd }}</td>
                          <td>
                            <div class="d-inline-block">
                              {{ item.unidades }}
                            </div>
                            <div
                              class="d-inline-block"
                              v-if="!checkIsEmpty(item.medida)"
                            >
                              {{ item.medida.nome }}
                            </div>
                            <div
                              class="d-inline-block"
                              v-else-if="item.medida_nome !== null"
                            >
                              {{ item.medida_nome }}
                            </div>
                            <div class="d-inline-block" v-else>Sem Medida</div>
                          </td>
                          <td>
                            <div v-if="!checkIsEmpty(item.marca)">
                              {{
                                typeof item.marca === 'object'
                                  ? item.marca.nome
                                  : item.marca
                              }}
                            </div>
                            <div v-else-if="item.marca_nome !== null">
                              {{ item.marca_nome }}
                            </div>
                            <div v-else>Sem Marca</div>
                          </td>
                          <td
                            v-if="item.adicionarFoto !== null"
                            class="subImage text-center"
                          >
                            <a class="pointer">
                              <img
                                class="img-small"
                                :src="
                                  `${getImagesAddress}` + item.adicionarFoto
                                "
                              />
                            </a>
                            <div class="position-relative">
                              <div
                                class="btn-remove"
                                @click="
                                  deleteProductPhoto(item.adicionarFoto, index)
                                "
                              >
                                <i class="fas fa-times"></i>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="sub-header py-2">
                  <div
                    style="width: 10%"
                    class="number c-gray-2 icon-align ml-0"
                  ></div>
                  <span class="fs-18"> Opções de entrega </span>
                </div>

                <div class="sub-text field-escolha">
                  <span @click="validQunatityProduct()"></span>
                  <div class="title-entrega">Escolha sua forma de entrega:</div>

                  <p
                    style="width: 283px"
                    class="error-message text-danger mr-5"
                    v-if="errorMessagesQuote.delivery !== null"
                  >
                    {{ errorMessagesQuote.delivery }}
                  </p>

                  <!-- ENTREGAR NA OBRA!!!!!!!!!!! -->
                  <div class="content-entrega align-self-start">
                    <div class="mt-2">
                      <i
                        class="fas fa-shipping-fast fs-24 mr-3"
                        style="color: gray"
                      ></i>
                      <div
                        class="d-inline-block position-relative p-right-10px"
                      >
                        <input
                          type="radio"
                          class="custom-control-input"
                          id="cep"
                          v-model="tipoEntrega"
                          value="1"
                          @input="errorMessagesQuote.delivery = null"
                        />
                        <label class="custom-control-label my-1" for="cep">
                          <a class="pointer black-link">Entregar na Obra</a>
                        </label>
                      </div>

                      <!-- RETIRAR NA LOJAAAAAAAAAAAAAA -->
                      <br />
                      <i
                        class="fas fa-store fs-24 mr-3"
                        style="color: gray"
                      ></i>
                      <div
                        class="d-inline-block position-relative p-right-10px"
                      >
                        <input
                          type="radio"
                          class="custom-control-input"
                          id="retirarnaloja"
                          v-model="tipoEntrega"
                          value="2"
                          @input="errorMessagesQuote.delivery = null"
                        />
                        <label class="custom-control-label" for="retirarnaloja">
                          <a class="pointer black-link">Retirar na Loja</a>
                        </label>
                      </div>
                    </div>

                    <div
                      class="d-inline-block position-relative p-right-10px mt-2"
                      v-if="tipoEntrega === '1'"
                    >
                      <input
                        type="text"
                        class="form-control w-190px"
                        v-mask="'##.###-###'"
                        id="campoCep"
                        v-model="cep"
                        placeholder="Digite o CEP para entrega"
                      />
                    </div>
                  </div>
                </div>
                

                <div class="sub-text mb-negative-1v25em text-center">
                  <b-button
                    class="btn-lg btn-success enviar-cotacao"
                    @click="enviarCotacao()"
                    v-if="stateButton === false"
                  >
                    <a class="pointer btn-enviar" id="sendCotation">
                      Enviar Orçamento
                      <i class="fas fa-paper-plane ml-2"></i>
                    </a>
                  </b-button>

                  <div class="btn btn-lg btn-success enviar-cotacao" v-else>
                    <a class="pointer btn-enviar">Enviando...</a>
                  </div>
                  <br />
                </div>


                <div class="font-bigger">
                  <span>Grátis e sem compromisso!</span>
                </div>
              </b-card>
            </b-card-group>
          </div>
        </div>
      </div>
    </div>
    <div class="else" v-else>
      <div class="container">
        <div class="row">
          <div class="col-12 mt-3">
            <h1 class="title font-weight-bold text-uppercase">
              Esse tipo de usuário não pode realizar um orçamento
            </h1>
            <hr class="linha-amarela" />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      title="Preencha suas informações básicas"
      size="xl"
      id="basicInformation"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      no-close-on-backdrop
    >
      <div class="col-12">
        <div class="form-group">
          <label for="choosetipo_cliente">Você é uma</label>
          <b-form-radio-group
            id="choosetipo_cliente"
            name="choosetipo_cliente"
            @change="errorMessages.client_type = null"
          >
            <b-form-radio v-model="basicInformation.tipo_cliente" :value="1">
              <a class="pointer">Pessoa Física</a>
            </b-form-radio>

            <b-form-radio v-model="basicInformation.tipo_cliente" :value="2">
              <a class="pointer">Pessoa Jurídica</a>
            </b-form-radio>
          </b-form-radio-group>
          <p
            v-if="errorMessages.client_type !== null"
            class="error-message text-danger"
          >
            {{ errorMessages.client_type }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="telephone"> Telefone </label>
          <input
            type="text"
            class="form-control"
            id="telephone"
            name="telephone"
            v-model="basicInformation.telefone"
            v-mask="['(##) #####-####', '(##) ####-####']"
            placeholder="Digite seu telefone"
            @input="errorMessages.telephone = null"
          />
          <p
            class="error-message text-danger"
            v-if="errorMessages.telephone !== null"
          >
            {{ errorMessages.telephone }}
          </p>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="cidade_id"> Cidade </label>
          <v-select
            id="cidade_id"
            name="cidade_id"
            label="nome"
            v-model="basicInformation.cidade_id"
            :options="cidades"
            :reduce="(city) => city.id"
            placeholder="Selecione a cidade"
            @input="errorMessages.city_id = null"
          >
            <div slot="no-options">Nenhuma cidade foi encontrada.</div>
          </v-select>
          <p
            class="error-message text-danger"
            v-if="errorMessages.city_id !== null"
          >
            {{ errorMessages.city_id }}
          </p>
        </div>
      </div>

      <template v-slot:modal-footer>
        <div>
          <button
            type="button"
            class="btn btn-success btn-lg"
            @click="saveBasicInformation()"
          >
            Salvar
            <i class="fas fa-check-circle ml-2"></i>
          </button>
        </div>
      </template>
    </b-modal>

    <!-- <b-modal ref="modalWarnning" centered hide-footer hide-header>
      <div class="text-center m-3">
        <label class="fs-18 d-block">
          Seu orçamento será respondido pelos lojistas cadastrados somente em
          dias úteis no horário comercial
        </label>
        <div>
          <button
            class="my-3 btn bg-orange c-white w-75 fs-22 border-secondary"
            @click="enviarCotacao()"
          >
            Entendi
          </button>
        </div>
        <span @click="hideModal()" class="c-pointer btn border-secondary">
          Cancelar
        </span>
      </div>
    </b-modal> -->

    <!-- <b-modal id="confirmFile" centered hide-footer hide-header size="sm">
    <h2 class="text-center font-weight-bold fs-24 c-orange">
      Sua imagem/arquivo foi anexado
    </h2>
    <div class="text-center fs-18">
      Deseja excluir o 1º produto?
    </div>
    <div class="text-right">
      <b-button
        variant="success"
        class="mt-3 fs-18 c-white mr-3"
        @click="() => {
          removeProduct();
          hide('confirmFile');
        }"
      >
        Sim
      </b-button>
      <b-button
      variant="danger"
      class="mt-3 fs-18 c-white"
      @click="hide('confirmFile');">
        Não
      </b-button>
    </div>
  </b-modal> -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Axios from 'axios';
import { Loader } from 'google-maps';
import { setInterval } from 'timers';
import makeToast from '../mixins/makeToast';
import userTypes from '../enums/UserTypes';
import ToggleOpenIcon from '../components/ToggleOpenIcon.vue';
import modal from '../mixins/modal';
import api from '../api';
import { StreamBarcodeReader } from "vue-barcode-reader";
import VoiceText from '../components/VoiceText';

export default {
  name: 'fazer-cotacao',
  mixins: [makeToast, modal],
  components: {
    ToggleOpenIcon,
    StreamBarcodeReader,
    VoiceText
  },
  data() {
    return {
      mostButton: false,
      warningMessage: '*Insira uma quantidade',
      messageInput: false,
      payBlock: true,
      productBarcode: '',
      validEmailUser: '',
      showEmailUser: {
        id: null
      },
      barcode: false,
      qtd: false,
      city: '',
      lojistas: false,
      radius: 20,
      zoom: 10.2,
      address: [],
      dataAddress: {
        cities: '',
        segments: [],
      },
      lowPrice: false,
      isClicked: false,
      isClicked1: false,
      isClicked2: false,
      initialProduct: false,
      productSelect: false,
      Archive: false,
      ProductPhoto: false,
      userTypes,
      files: [],
      file: null,
      quantidade_arquivo: null,
      imagem: [],
      foto: null,
      quantidade_foto: null,
      correpondente: 1, // A quem é correspondente.
      cidadesDePedido: [], // As cidades escolhidas no pedido.
      segmentosDaCotacao: [], // Os segmentos da cotação.
      prioridade: 1, // Prioridade no pedido.
      listaDeProdutos: [], // Lista de produtos selecionados.
      idAtualLista: null, // Id da lista selecionada.
      rowsProdutos: 0, // Numero de colunas de lista de produtos.
      tipoEntrega: 0,
      cep: '',
      nome_cotacao: '',
      stateButton: false,
      originalFileName: null,
      validFiles: false,
      basicInformation: {
        tipo_cliente: null,
        telefone: null,
        cidade_id: null,
        estado_id: 25,
      },
      errorMessages: {
        client_type: null,
        telephone: null,
        city_id: null,
        state_id: null,
        brand: null,
      },
      errorMessagesQuote: {
        city: null,
        segment: null,
        product: [],
        amount: [],
        delivery: null,
        preference: null,
      },
      searchProductsResult: [],
      mostrarSeguimentos: [],
      newSegmentosDaCotacao: [],
      ativaSeguimentos: false,
    };
  },
  watch: {
    radius(n) {
      if (n <= 2) {
        this.zoom = 14.5;
      } else if (n === 2) {
        this.zoom = 13.5;
      } else if (n > 2 && n <= 5) {
        this.zoom = 12.2;
      } else if (n > 5 && n <= 10) {
        this.zoom = 11.2;
      } else if (n > 10 && n <= 20) {
        this.zoom = 10.2;
      } else if (n > 20 && n <= 40) {
        this.zoom = 9.2;
      } else if (n > 40 && n <= 60) {
        this.zoom = 8.6;
      } else if (n > 60 && n <= 80) {
        this.zoom = 8.2;
      } else if (n > 80 && n <= 120) {
        this.zoom = 7.9;
      } else if (n > 120 && n <= 200) {
        this.zoom = 7;
      } else if (n > 200 && n <= 300) {
        this.zoom = 6.5;
      } else if (n > 300 && n <= 500) {
        this.zoom = 5.5;
      }
      localStorage.setItem('radiusMap', this.radius);
    },
    imagem() {
      this.validateProductsFields();
    },
    file() {
      this.validateProductsFields();
    },
  },

  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapState([
      'token',
      'dadosUsuario',
      'tipoUsuarios',
      'tipoMedidas',
      'estados',
      'cidades',
      'produtos',
      'produtoMarcas',
      'categoriasProduto',
      'segmentos',
    ]),
    // filtra as cidades que não são null
    cidadesDePedidoIdx() {
      return this.cidadesDePedido.filter((v) => v).map((v) => v.id);
    },
    // filtra os segmentos que não são null
    segmentosDaCotacaoIdx() {
      return this.segmentosDaCotacao.filter((v) => v).map((v) => v.id);
    },
    ...mapGetters(['getNotification', 'getTipoNotification']),
    acceptedFilesTypes() {
      return [
        'image/jpg',
        'image/jpeg',
        'image/png',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ];
    },

    teste: function() {
      const index = this.listaDeProdutos.length -1
      const myNumber = this.listaDeProdutos[index].qtd;
      return myNumber == 0 ? this.messageInput = true : this.messageInput = false;
    },
  },

  created() {
    this.$store.dispatch('loadTipoUsuarios');
    this.$store.dispatch('loadTipoMedidas');
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadProdutos');
    this.$store.dispatch('loadProdutoMarcas');
    this.$store.dispatch('loadCategoriasProduto');
    this.$store.dispatch('loadSegmentos');
    this.addRowCity();
    this.addRowSegment();
    this.setCorresponding();
  },
  beforeMount() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'fazer-nova-cotacao' });
    }
  },
  beforeUpdate() {
    if (this.$router.history.current.name === 'fazer-cotacao') {
      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: 'fazer-nova-cotacao' });
      }
    }
  },
  methods: {
    onDecode (result) {
      this.productBarcode = result;
      this.$bvModal.hide('leitor');
      this.setProductBarcode();    
    },


      activeInput(indexacao) {
        const myNumberr = this.listaDeProdutos[indexacao].qtd;
        return myNumberr > 1 ? this.mostButton = true : null;
      },


      mostInput(indexacao) {
        const myNumberr = this.listaDeProdutos[indexacao].qtd;
        return myNumberr == null ? this.mostButton = false : null;
      },

    subNumber (index) {
      const subBtnLess = document.getElementById('btn-sub');
      if(this.listaDeProdutos[index].qtd < 2) {
        subBtnLess.classList.add("none-btn")
      } else { 
      let numberLess = this.listaDeProdutos[index].qtd;
      numberLess --;
      this.listaDeProdutos[index].qtd = numberLess;
      }
    },

    addNumber (index) {
      let numberMore = 0;
      const subBtnMore = document.getElementById('btn-sub');
      numberMore = this.listaDeProdutos[index].qtd;
      numberMore ++;
      this.listaDeProdutos[index].qtd = numberMore;
      subBtnMore.classList.remove("none-btn");
    },

    setProductBarcode(){  
      this.setEnableSegments();    
      if(this.listaDeProdutos.length !==0){	
        let index = this.listaDeProdutos.length -1
        this.$store
          .dispatch('showProductBarcode', this.productBarcode)
          .then((response)=>{       
            if(response.data.nome){
              this.productBarcode = response.data.nome
              this.listaDeProdutos[index].produto = this.productBarcode
            }
            else{
              this.makeToast(
                'Oopss!',
                'O produto solicitado não existe em nossa base de dados!',
                'danger'
              );
            }
          })
          .catch(() => {
              this.makeToast(
                'Oopss!',
                'Algo deu errado, favor tentar novamente',
                'danger'
              );
          });
      }    
    },

    modalBarcode() {
      this.$bvModal.show('leitor');
      this.$bvModal.hide('leitor');
    },
    setProductVoice(textvoice){   
      this.setEnableSegments();
      if(this.listaDeProdutos.length !==0){	
        let index = this.listaDeProdutos.length -1
        this.listaDeProdutos[index].produto = textvoice
      }    
    },

    async getLocationBtn() {
      navigator.geolocation.getCurrentPosition(async (res) => {
        localStorage.setItem('mapLatitude', res.coords.latitude);
        localStorage.setItem('mapLongitude', res.coords.longitude);
        await this.populateMap(true);
        await this.setCity();
      });
    },
    showUserValid() {
      const self = this
      self.$store.dispatch('startLoader');
      this.$store
          .dispatch('admin/showClient', this.validEmailUser)
          .then((response) => {
            this.showEmailUser = response.data;
          })
          .catch(() => {
            self.makeToast(
              'Oopss!',
              'Não foi possível encontrar o cliente, tente novamente!',
              'danger'
            );
          });
        self.$store.dispatch('endLoader');
    },
    consultLow() {
      let local = false;
      if (localStorage.getItem('lowestPrice')) {
        local = localStorage.getItem('lowestPrice');
        localStorage.removeItem('lowestPrice');
      }

      this.lowPrice = local;
    },
    async populateMap(isBtn = false) {
      const coords = {
        latitude: localStorage.getItem('mapLatitude'),
        longitude: localStorage.getItem('mapLongitude'),
      };
      let sendQuote;
      if (this.segmentosDaCotacao[0]) {
        sendQuote = {
          latitude: coords.latitude,
          longitude: coords.longitude,
          distance: localStorage.getItem('radiusMap'),
          segments: this.reduceSegments(),
        };
      } else {
        sendQuote = {
          latitude: coords.latitude,
          longitude: coords.longitude,
          distance: localStorage.getItem('radiusMap') || this.radius,
        };
      }

      const request = await api.post('/quote/count/shopkeepers', sendQuote);
      let data = await request.data;
      if (data) {
        this.lojistas = data.count;
        if (data.address) {
          const newsCities = [];
          let cities = data.address.map((item) => item.cidade_id);
          cities = Array.from(new Set(cities));
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const i in cities) {
            newsCities.push({ id: cities[i] });
          }
          this.cidadesDePedido = newsCities;
        }
      }
      if (!localStorage.getItem('cityGeoData') || isBtn) {
        const response = await Axios.get(
          `https://api.opencagedata.com/geocode/v1/json?q=${coords.latitude}+${coords.longitude}&key=610f77b3d3d24bc384a962a9a35895fb`
        );
        data = await response.data;
        const result = (await data.results[0].formatted) || '';
        localStorage.setItem('cityGeoData', result);
        localStorage.setItem('cityResult', data.results[0].components.city);
        this.dataAddress.cities = data.results[0].components.city;
        this.$refs.origin_search.value = result;
      }
      if (localStorage.getItem('cityGeoData')) {
        this.$refs.origin_search.value = localStorage.getItem('cityGeoData');
      }
    },
    changeInput() {
      document
        .getElementById('rangeinput')
        .addEventListener('change', async (e) => {
          e.preventDefault();
          const coords = {
            latitude: localStorage.getItem('mapLatitude'),
            longitude: localStorage.getItem('mapLongitude'),
          };
          let sendQuote;
          if (this.segmentosDaCotacao[0]) {
            sendQuote = {
              latitude: coords.latitude,
              longitude: coords.longitude,
              distance: localStorage.getItem('radiusMap'),
              segments: this.reduceSegments(),
            };
          } else {
            sendQuote = {
              latitude: coords.latitude,
              longitude: coords.longitude,
              distance: localStorage.getItem('radiusMap'),
            };
          }
          const request = await api.post('/quote/count/shopkeepers', sendQuote);
          const data = await request.data;
          if (data) {
            this.lojistas = data.count;
            if (data.address) {
              const newsCities = [];
              let cities = data.address.map((item) => item.cidade_id);
              cities = Array.from(new Set(cities));
              // eslint-disable-next-line guard-for-in,no-restricted-syntax
              for (const i in cities) {
                newsCities.push({ id: cities[i] });
              }
              this.cidadesDePedido = newsCities;
            }
          }
        });
    },
    async getLocation() {
      if (
        !localStorage.getItem('mapLatitude') &&
        !localStorage.getItem('mapLongitude')
      ) {
        navigator.geolocation.getCurrentPosition(async (res) => {
          localStorage.setItem('mapLatitude', res.coords.latitude);
          localStorage.setItem('mapLongitude', res.coords.longitude);
          await this.populateMap();
        });
      } else {
        await this.populateMap();
      }
    },
    async setCity() {
      const options = {
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: false,
      };
      const loader = new Loader('AIzaSyA1RK-idXt1tw1QQTnrQBGYGB9o-lL_Od0', {
        libraries: ['places'],
      });
      const google = await loader.load();
      await navigator.permissions
        .query({ name: 'geolocation' })
        .then((result) => {
          if (result.state === 'prompt') {
            navigator.geolocation.getCurrentPosition((res) => {
              localStorage.setItem('mapLatitude', res.coords.latitude);
              localStorage.setItem('mapLongitude', res.coords.longitude);
            });
          }
        });
      const latlon = await new google.maps.LatLng(
        localStorage.getItem('mapLatitude'),
        localStorage.getItem('mapLongitude')
      );
      const map = new google.maps.Map(document.getElementById('map'), {
        zoom: this.zoom,
        gestureHandling: 'none',
        center: latlon,
        options,
      });
      new google.maps.event.trigger(map, 'resize');
      setInterval(() => {
        map.setZoom(this.zoom);
      }, 800);
      const circle = new google.maps.Circle({
        center: latlon,
        map,
        radius: this.radius,
        strokeColor: '#EE731F',
        strokeOpacity: 0.6,
        strokeWeight: 1,
        fillColor: '#EE731F',
        fillOpacity: 0.3,
      });
      // eslint-disable-next-line no-new
      const marker = new google.maps.Marker({ position: latlon, map });
      const autocomplete = new google.maps.places.Autocomplete(
        document.querySelector('.search')
      );
      setInterval(() => {
        circle.setRadius(parseFloat(this.radius) * 1000);
      }, 10);
      autocomplete.addListener('place_changed', async () => {
        const place = autocomplete.getPlace();
        localStorage.setItem('cityGeoData', place.formatted_address);
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(this.zoom);
        }
        localStorage.setItem('mapLatitude', place.geometry.location.lat());
        localStorage.setItem('mapLongitude', place.geometry.location.lng());
        const sendQuote2 = {
          latitude: localStorage.getItem('mapLatitude'),
          longitude: localStorage.getItem('mapLongitude'),
          distance: this.radius,
        };
        const request2 = await api.post('/quote/count/shopkeepers', sendQuote2);
        const dataChange = await request2.data;
        if (dataChange) {
          this.lojistas = dataChange.count;
          if (dataChange.address) {
            const newsCities = [];
            let cities = dataChange.address.map((item) => item.cidade_id);
            cities = Array.from(new Set(cities));
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            for (const i in cities) {
              newsCities.push({ id: cities[i] });
            }
            this.cidadesDePedido = newsCities;
          }
        }
        const response2 = await Axios.get(
          `https://api.opencagedata.com/geocode/v1/json?q=${place.geometry.location.lat()}+${place.geometry.location.lng()}&key=610f77b3d3d24bc384a962a9a35895fb`
        );
        const data2 = response2.data;
        this.dataAddress.cities = data2.results[0].components.city;
        localStorage.setItem('cityResult', this.dataAddress.cities);
        map.setCenter(place.geometry.location);
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);
        circle.setCenter(place.geometry.location);
        map.setZoom(this.zoom);
        circle.setRadius(parseFloat(this.radius) * 1000);
        circle.setVisible(true);
      });
    },
    getCity() {
      setInterval(() => {
        this.city = localStorage.getItem('cityResult');
      }, 1);
    },
    toggleButton() {
      this.isClicked = !this.isClicked;
    },
    toggleButton1() {
      this.isClicked1 = !this.isClicked1;
    },
    toggleButton2() {
      this.isClicked2 = !this.isClicked2;
      this.ProductPhoto = !this.ProductPhoto;
    },
    // retorna as cidades filtradas
    getCidadeItem(cidadesDePedido) {
      let id = null;
      if (cidadesDePedido) {
        id = cidadesDePedido.id;
      }
      const idx = this.cidadesDePedidoIdx.filter((v) => v !== id);
      return this.cidades.filter((v) => !idx.includes(v.id));
    },
    // retorna os segmentos filtrados
    getSegmentoItem(segmentosDaCotacao) {
      let id = null;
      if (segmentosDaCotacao) {
        id = segmentosDaCotacao.id;
      }
      const idx = this.segmentosDaCotacaoIdx.filter((v) => v !== id);
      return this.segmentos.filter((v) => !idx.includes(v.id));
    },

    setCorresponding() {
      if (
        this.dadosUsuario.tipo_usuario === 'Cliente' ||
        this.dadosUsuario.tipo_usuario === 'Profissional'
      ) {
        this.correpondente = 3;
      } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
        this.correpondente = 4;
      }
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    getTheIdLista(id) {
      this.idAtualLista = id;
    },
    addFiles() {
      const self = this;
      this.validFiles = false;
      const formData = new FormData();
      const element = document.getElementById('photo');
      const allFiles = element.files;

      // if (this.listaDeProdutos[0] && this.imagem.length === 0) {
      //   this.show('confirmFile');
      // }

      // if (this.imagem !== null) {
      //   if (this.imagem.length > 4) {
      //     self.makeToast('Oopss!', 'Você já selecionou 5 imagens!', 'danger');
      //     return;
      //   }
      // }
      if (this.validateFiles(allFiles)) {
        this.validFiles = true;
        this.$store.dispatch('startLoader');
        // eslint-disable-next-line no-restricted-syntax
        for (const file of allFiles) {
          formData.append('files[]', file);
        }
        this.$store
          .dispatch('files/uploadFiles', formData)
          .then((response) => {
            if (self.imagem !== null) {
              // eslint-disable-next-line no-restricted-syntax
              for (const filename of response.data.data) {
                self.imagem.push(filename);
              }
            } else {
              self.imagem = response.data.data;
            }
            self.makeToast(
              'Sucesso',
              'Imagens inseridas com sucesso!',
              'success'
            );
          })
          .catch(() => {
            self.makeToast(
              'Oopss!',
              'Não foi possível inserir suas imagens, tente novamente em 5 minutos!',
              'danger'
            );
          });
        this.$store.dispatch('endLoader');
      }
    },
    addFile() {
      const self = this;
      this.validFiles = false;
      const formData = new FormData();
      const element = document.getElementById('file');
      const file = element.files;

      // if (this.listaDeProdutos[0] && this.file === null) {
      //   this.show('confirmFile');
      // }

      // if (this.file !== null) {
      //   self.makeToast('Oopss!', 'Você já selecionou 1 arquivo!', 'danger');
      //   return;
      // }
      if (this.validateFiles(file)) {
        // this.$store.dispatch('startLoader');
        formData.append('file', file[0]);
        this.validFiles = true;
        this.$store
          .dispatch('files/sendUploadFiles', formData)
          .then((response) => {
            self.originalFileName = file[0].name;
            self.file = response.data.data;
            self.makeToast(
              'Sucesso',
              'Arquivo inserido com sucesso!',
              'success'
            );
          })
          .catch(() => {
            self.makeToast(
              'Oopss!',
              'Não foi possível inserir o arquivo, porque este formato não é permitido!',
              'danger'
            );
          });
        this.$store.dispatch('endLoader');
      }
    },
    addProductPhoto(id) {
      const self = this;
      const formData = new FormData();
      const indentador = parseInt(id) + 1;
      const name = `file${indentador}`;
      const file = document.getElementById(name).files;
      if (this.validateFiles(file)) {
        this.$store.dispatch('startLoader');
        formData.append('file', file[0]);
        this.$store
          .dispatch('files/sendUploadFiles', formData)
          .then((response) => {
            self.listaDeProdutos[id].adicionarFoto = response.data.data;
            self.makeToast(
              'Sucesso',
              'Imagem do produto inserida com sucesso!',
              'success'
            );
          })
          .catch(() => {
            self.makeToast(
              'Oopss!',
              'Não foi possível inserir a imagem do produto, tente novamente em 5 minutos!',
              'danger'
            );
          });
        this.$store.dispatch('endLoader');
      }
    },
    deleteFile(filename) {
      const self = this;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('files/deleteFile', filename)
        .then(() => {
          self.originalFileName = null;
          self.file = null;
          self.makeToast('Sucesso', 'Arquivo removido com sucesso!', 'success');
        })
        .catch(() => {
          self.makeToast(
            'Oopss!',
            'Ooops! Houve algum erro ao remover o arquivo!',
            'danger'
          );
        });
      this.$store.dispatch('endLoader');
    },
    deleteImage(filename, index) {
      const self = this;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('files/deleteFile', filename)
        .then(() => {
          self.imagem.splice(index, 1);
          self.makeToast('Sucesso', 'Imagem removida com sucesso!', 'success');
        })
        .catch(() => {
          self.imagem.splice(index, 1);
          self.makeToast(
            'Oopss!',
            'Ooops! Houve algum erro ao remover a imagem!',
            'danger'
          );
        });
      this.$store.dispatch('endLoader');
    },
    deleteProductPhoto(filename, index) {
      const self = this;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('files/deleteFile', filename)
        .then(() => {
          self.listaDeProdutos[index].adicionarFoto = null;
          self.makeToast(
            'Sucesso',
            'Imagem do produto removida com sucesso!',
            'success'
          );
        })
        .catch(() => {
          self.listaDeProdutos[index].adicionarFoto = null;
          self.makeToast(
            'Oopss!',
            'Ooops! Houve algum erro ao remover a imagem do produto!',
            'danger'
          );
        });
      this.$store.dispatch('endLoader');
    },
    enviarCotacao() {
      let user_id = this.dadosUsuario.id;
      if (this.dadosUsuario.tipo_usuario == 'Administrador') {
        if(this.showEmailUser.id < 0) {
          this.makeToast(
            'Oopss!',
            'Informe o cliente para essa cotação!',
            'danger'
          );
          return;
        }
        user_id = this.showEmailUser.id;
        this.correpondente = 3;
      }

      const data = {
        cep: this.cep,
        nome_cotacao: this.nome_cotacao,
        correpondente: this.correpondente,
        segmentos: this.segmentosDaCotacao,
        cidades: this.cidadesDePedido,
        prioridade: this.prioridade,
        produtos: this.listaDeProdutos,
        usuario: user_id,
        foto: this.foto,
        file: this.file,
        imagem: this.imagem,
        quantidade_arquivo: this.quantidade_arquivo,
        quantidade_foto: this.quantidade_foto,
      };

      if(this.listaDeProdutos.length > 0){
        const index = this.listaDeProdutos.length -1
        const myNumber = this.listaDeProdutos[index].qtd;
        if(myNumber == 0 || myNumber == null) {
          this.messageInput = true;
          this.makeToast('Oopss!','Parece que há campos inválidos! Corrija-os e tente novamente','danger');
          return;
        }
      }
       
      if (
        this.listaDeProdutos.length !== 0 ||
        this.file !== null ||
        this.imagem.length !== 0 ||
        this.foto !== null
      ) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('insertCotacao', data)
          .then((data) => {
            console.log(data);
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Sucesso',
              'Seu orçamento foi realizado com sucesso!',
              'success'
            );
            this.stateButton = true;
            this.currentTab = 0;
            setTimeout(() => {
              if (this.dadosUsuario.tipo_usuario === 'Cliente') {
                this.$router.push({ name: 'cliente-meus-dados' });
              } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
                this.$router.push({ name: 'lojista-meus-dados' });
              } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
                this.$router.push({ name: 'profissional-meu-perfil' });
              } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
                this.$router.push({ name: 'representante-meus-dados' });
              } else if (this.dadosUsuario.tipo_usuario === 'Administrador') {
                this.$router.push({ name: 'administrador-meus-dados' });
              }
            }, 1000);
          })
          .catch(() => {});
      } else {
        this.makeToast(
          'Ooppss!',
          'Necessita ter produtos, lista de excel com produtos, imagem ou foto',
          'warning'
        );
      }
    },
    addRowSegment() {
      if (this.segmentosDaCotacao.length <= this.segmentos.length) {
        this.segmentosDaCotacao.push(null);
      }
    },
    addRowCity() {
      if (this.cidadesDePedido.length <= this.cidades.length) {
        this.cidadesDePedido.push(null);
      }
    },
    addRowProduct() {
      this.rowsProdutos++;
      this.listaDeProdutos.push({
        id: this.rowsProdutos,
        produto: null,
        produto_nome: null,
        tipo_obj: true,
        qtd: null,
        unidades: null,
        medida: null,
        medida_nome: null,
        medida_tipo_obj: true,
        marca: null,
        marca_nome: null,
        marca_tipo_obj: true,
        adicionarFoto: null,
      });

      this.errorMessagesQuote.product.push(null);
      this.errorMessagesQuote.amount.push(null);
    },
    removeProduct(index) {
      this.listaDeProdutos.splice(index, 1);
    },
    removeCity(index) {
      this.cidadesDePedido.splice(index, 1);
    },
    removeSegment(index) {
      this.segmentosDaCotacao.splice(index, 1);
    },
    validateFiles(files) {
      if (files.length === 0) {
        this.makeToast(
          'Oopss!',
          'Você não selecionou nenhum arquivo!',
          'warning'
        );
        return false;
      }
      if (files.length > 5) {
        this.makeToast(
          'Oopss!',
          'Você selecionou mais de 5 arquivos!',
          'danger'
        );
        return false;
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const image of files) {
        if (!this.validateFileType(image) || !this.validateFileSize(image)) {
          return false;
        }
      }
      return true;
    },
    validateFileType(image) {
      if (this.acceptedFilesTypes.includes(image.type)) {
        return true;
      }
      this.makeToast('Oopss!', 'O tipo de arquivo é inválido!', 'danger');
      return false;
    },
    validateFileSize(image) {
      if (image.size <= 5242880) {
        return true;
      }
      this.makeToast(
        'Oopss!',
        'O tamanho do arquivo ultrapassa 5MB!',
        'danger'
      );
      return false;
    },
    saveBasicInformation() {
      if (this.validateBasicInformation()) {
        this.$store.dispatch('startLoader');
        const clientData = {
          id: this.dadosUsuario.informacoes.id,
        };
        Object.assign(this.basicInformation, clientData);
        this.$store
          .dispatch('client/saveBasicInformation', this.basicInformation)
          .then(() => {
            this.$store.dispatch('endLoader');
            this.setNewClientData();
            this.makeToast('Sucesso!', 'Informações salvas com sucesso!');
            this.$bvModal.hide('basicInformation');
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Oopss!',
              'Parece que houve um erro ao salvar suas informações, tente novamente mais tarde',
              'danger'
            );
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    validateBasicInformation() {
      let isValid = true;
      if (
        this.basicInformation.tipo_cliente === null ||
        (this.basicInformation.tipo_cliente !== userTypes.CLIENT &&
          this.basicInformation.tipo_cliente !== userTypes.PROFESSIONAL)
      ) {
        this.errorMessages.client_type = 'Por favor, selecione o seu tipo';
        isValid = false;
      }
      if (!this.$validate.telephone(this.basicInformation.telefone)) {
        this.errorMessages.telephone = 'Telefone inválido';
        isValid = false;
      }

      if (this.basicInformation.cidade_id === null) {
        this.errorMessages.city_id = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.basicInformation.estado_id === null) {
        this.errorMessages.state_id = 'Você não selecionou nenhum estado';
        isValid = false;
      }

      if (this.basicInformation.marca === null) {
        this.errorMessages.brand = 'Você não digitou nenhuma marca';
        isValid = false;
      }
      return isValid;
    },
    validQunatityProduct() {
      let resultQtd = this.listaDeProdutos.map((prod) => prod.qtd > 0);
      resultQtd.includes(false) ? (this.qtd = false) : (this.qtd = true);
    },
    validateQuoteFields() {
      let isValid = true;
      this.validQunatityProduct();

      if (!this.cidadesDePedido[0]) {
        this.errorMessagesQuote.city = 'Você não selecionou nenhuma cidade';
        isValid = false;
      }

      if (this.listaDeProdutos.length > 0 && this.qtd == false) {
        this.makeToast(
          'Erro',
          'Você não adicionou quantidade a todos os produtos da lista',
          'danger'
        );
        isValid = false;
      }

      if (
        !this.segmentosDaCotacao[0] &&
        this.newSegmentosDaCotacao.length === 0
      ) {
        this.errorMessagesQuote.segment = 'Você não selecionou nenhum segmento';
        isValid = false;
      }

      if (!this.prioridade) {
        this.errorMessagesQuote.preference =
          'É preciso escolher uma preferência';
        isValid = false;
      }
    },
    validateProductsFields() {
      if (!this.file && !this.imagem[0]) {
        this.listaDeProdutos.forEach((product, index) => {
          if (product.produto == null) {
            this.errorMessagesQuote.product[index] = 'Obrigatório';
          }
          if (product.qtd == null) {
            this.errorMessagesQuote.amount[index] = 'Obrigatório';
          }
          if (!this.tipoEntrega) {
        this.errorMessagesQuote.delivery =
          'Você não selecionou nenhum tipo de entrega';
        isValid = false;
      }
        });
      } else {
        this.listaDeProdutos.forEach((product, index) => {
          this.errorMessagesQuote.product[index] = null;
          this.errorMessagesQuote.amount[index] = null;
        });
      }
    },
    async setNewClientData() {
      this.$store.dispatch('startLoader');
      const currentUserData = this.dadosUsuario;
      currentUserData.informacoes.tipo_cliente =
        this.basicInformation.tipo_cliente;
      currentUserData.informacoes.cidade_id = this.basicInformation.cidade_id;
      currentUserData.informacoes.telefone = this.basicInformation.telefone;
      await this.$store.commit('setDadosUsuario', currentUserData);
      localStorage.removeItem('dadosUsuario');
      localStorage.setItem('dadosUsuario', JSON.stringify(currentUserData));
      this.$store.dispatch('endLoader');
    },
    setEnableSegments() {
      this.mostrarSeguimentos = this.listaDeProdutos.filter(
        (produto) =>
          produto.produto &&
          produto.produto.segmentos &&
          produto.produto.segmentos.length > 0
      );

      if (this.mostrarSeguimentos.length > 0) {
        this.ativaSeguimentos = false;
        this.newSegmentosDaCotacao = this.mostrarSeguimentos.map((produto) => {
          produto.produto &&
            produto.produto.segmentos &&
            produto.produto.segmentos.length > 0;
          return produto.produto.segmentos;
        });
        this.segmentosDaCotacao = this.newSegmentosDaCotacao.reduce(
          (list, sub) => list.concat(sub),
          []
        );
      }

      if (this.mostrarSeguimentos.length < this.listaDeProdutos.length) {
        this.ativaSeguimentos = true;
      }
    },
    searchProducts(search) {
      if (search.length >= 2) {
        this.searchProductsResult = this.produtos.filter((product) =>
          product.nome.toLowerCase().includes(search.toLowerCase())
        );
      }
    },
   
   pushTagOnBlur(fieldObject, fieldIndex, fieldName, selectIdentifier) {
      this.setEnableSegments();
      if (
        this[fieldObject][fieldIndex][fieldName] &&
        typeof this[fieldObject][fieldIndex][fieldName] === 'object'
      ) {
        return true;
      }

      const select = this.$refs[`select${selectIdentifier}`][fieldIndex];

      if (!select.search) {
        return true;
      }

      this[fieldObject][fieldIndex][fieldName] = select.search;
      select.$refs.search.style.opacity = 1;

      return false;
    },
   
   isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      )
        return true;
      return false;
    },
  },
  mounted() {
    this.changeInput();
    this.setCity();
    this.getCity();
    this.getLocation();
    this.consultLow();
  },
};
</script>

<style>
#map {
  height: 55vh;
  width: 100%;
}
.mailClient {
  width: 300px !important;
}
.search {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  padding: 0 15px;
  width: calc(95% - 30px);
  height: 35px;
  border-radius: 10px;
  border: 2px solid #ee731f;
}
.range {
  width: 81%;
}
.city > div {
  position: relative;
  left: 0px;
  border: 2px solid #ee731f;
  border-radius: 10px;
  margin-top: 10px;
  padding: 05px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2vh;
}
.selector {
  width: 8%;
  background-color: #ee731f;
  color: #fff;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  outline: none;
  border: none;
  text-align: center;
}
.selector-h1 {
  width: 5%;
  padding: 1px 5px 1px 10px;
  background-color: #ee731f;
  color: #fff;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
ion-label {
  margin-bottom: 10px;
  font-size: 16px;
  color: #ee731f;
  font-weight: bold;
}
.city {
  padding: 0;
}
h4 {
  color: var(--orange-primary);
  margin-top: 10px;
  font-size: 24px;
}
#rangeinput {
  margin-right: 20px;
  background: black;
  -webkit-appearance: none;
  height: 2px;
}
#rangeinput::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: var(--orange-primary);
  cursor: pointer;
  border-radius: 50%;
}
#rangeinput::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--orange-primary);
  cursor: pointer;
}

.vs__search {
  width: 100% !important;
}

.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
  opacity: 10 !important;
}
.QNTD {
  max-width: 90px;
}
.opcional {
  font-size: 14px;
  color: #ed670c;
}
.fonte-laranja {
  color: #ed670c;
  font-size: 16px;
  font-style: Oswald, arial, helvetica, sans-serif;
  font-weight: bold;
  padding: 0px;
}

.custom_select_dots span.vs__selected {
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 275px;
  overflow: hidden;
  display: block;
}

.imagem-foto {
  color: black;
}
.box-opcional {
  margin-top: -20px;
  text-align: center;
}
.fonte-numero {
  font-size: 27px;
}
.font-bigger {
  color: black;
  font-size: 30px;
  font-style: Oswald, arial, helvetica, sans-serif;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
}
.cotacao-div {
  text-align: center;
  color: gray;
  font-size: 1.3em;
  transform: translateY(+35%);
  margin-top: -2%;
}
.bd-right {
  border-right: 2px solid lightgray;
}
.c-click {
  color: #ed670c;
  background-color: rgba(242, 79, 0, 0.1);
  border-radius: 10px;
}
.btn-enviar {
  color: white;
}
.btn-enviar:hover {
  color: white;
  text-decoration: none;
}
.black-link {
  color: black;
}
.black-link:hover {
  color: black;
  text-decoration: none;
}

#my-location {
  -webkit-appearance: none;
  background: transparent;
  border: none;
  margin-top: 5px;
  margin-bottom: 15px;
  color: var(--ck-color-base-active-focus);
  outline: none;
}
#my-location i {
  margin-right: 5px;
}
.custom_product > div {
  height: inherit !important;
  min-height: 38px !important;
}
.custom_product input {
  position: absolute;
}
.sizeIcon{
  width: 35px;
}
.btn-icon{
  background-color: white;
  border: solid 1px #ed670c;
  width: 70px;
  height: 40px;
  border-radius: 8px;
}
.btn-icon:hover{
  background-color: #ed670c;
  border: solid 1px white;
}

.number-input {
  padding: 0px;
}

.sub-button {
  color: #ED680D;
  font-size: 30px;
  width: 90px;
}

.cont-btn {
  background: #ED680D !important;
}

.none-btn {
  background: #FEEDE5 !important;
}

.add-button {
  color: #ED680D;
  font-size: 30px;
  border: none;
  transition: 1s;
}

.font-none{
  color: white;
}

.font-most {
  color: red;
}

.add-button:hover {
  color: #FEEDE5;
  font-size: 30px;
  border: none;
}

.box-qnt {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>